import { type App, defineAsyncComponent } from 'vue'

const components = {
  AssetBreadcrumb: defineAsyncComponent(() => import('./AssetBreadcrumb.vue')),
  AssetDrawer: defineAsyncComponent(() => import('./AssetDrawer.vue')),
  AssetFolderCardGrid: defineAsyncComponent(() => import('./AssetFolderCardGrid.vue')),
  AssetFolderHeader: defineAsyncComponent(() => import('./AssetFolderHeader.vue')),
  AssetKindFilter: defineAsyncComponent(() => import('./AssetKindFilter.vue')),
  AssetTileGrid: defineAsyncComponent(() => import('./AssetTileGrid.vue')),
  NewFolderDialog: defineAsyncComponent(() => import('./NewFolderDialog.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
